import { $q } from "@uirouter/core";

/**
 * @ngdoc Controller
 * @name WhatsnewChangelogController
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('AdminWhatsnewChangelogController', AdminWhatsnewChangelogController)
        .controller('AdminWhatsnewChangelogFormController', AdminWhatsnewChangelogFormController)
        .filter('timestampToISO', function() {
            return function(input) {
                input = new Date(input * 1000).toLocaleDateString();
                return input;
            };
        });
    /**
     * @constructor
     * @ngInject
     */
    function AdminWhatsnewChangelogController($log, $scope, AdminTableService, VrmModalService, vrmNotificationsService, vrmNotificationType, ApiService, locale) {
        $log.info('AdminWhatsnewChangelogController');
        $scope.table = new AdminTableService("whatsnew-changelog");

        $scope.remove = function (id) {
            VrmModalService.openConfirmModal($scope, 'delete', function (confirmed) {
                if (confirmed && id) {
                    ApiService.admin('whatsnew-changelog/' + id, {}, 'DELETE').then(function () {
                        locale.ready('admin').then(function () {
                            vrmNotificationsService.add({ type: vrmNotificationType.SUCCESS, message: locale.getString('admin.whatsnew_changelog_deleted') });
                            $scope.table.params.reload();
                        });
                    });
                }
            });
        }
    }

    /**
     * @constructor
     * @ngInject
     */
    function AdminWhatsnewChangelogFormController($log, $scope, $stateParams, ApiService, $state, vrmNotificationsService, locale, vrmNotificationType, VrmModalService) {
        $log.info('AdminWhatsnewChangelogFormController');

        var browseState = 'base.admin.whatsnew-changelog';

        $scope.editing = !!$stateParams.id;
        $scope.newImageName = '';
        $scope.whatsnew_changelog = {
            finishedLoading: false,
            createdAt: new Date()
        };

        var file = null;

        if ($scope.editing) {
            ApiService.admin('whatsnew-changelog', { 'filter[idWhatsnew]': $stateParams.id }).then(function (response) {
                if (response.data.num_records < 1) return;
                var resp = response.data.records;
                $scope.whatsnew_changelog = resp[0];
                $scope.whatsnew_changelog.finishedLoading = true;
                $scope.whatsnew_changelog.createdAt = new Date(resp[0].createdAt * 1000);
            });
        } else {
            $scope.whatsnew_changelog.finishedLoading = true;
        }

        $scope.addImage = function () {
            VrmModalService.openUploadModal($scope, 'image', function (files) {
                if (files.length > 0) {
                    file = new FormData();
                    file.append('image', files[0]);
                    $scope.newImageName = files[0].name;
                    $scope.newImage = true;
                }
            });
            $.magnificPopup.close();
        };

        $scope.removeImage = function () {
            $scope.whatsnew_changelog.imageName = '';
            $scope.whatsnew_changelog.imageFullPath = '';
            $scope.newImageName = '';
            file = new FormData();
        }

        $scope.doSave = function () {
            var imagename = $scope.whatsnew_changelog.imageName || '';

            var promises = [];
            if (file) {
                promises.push(ApiService.admin('upload-whatsnew-changelog-image', file, 'POST').then(function (response) {
                    imagename = response.data.filename;
                }))
            }
            $q.all(promises).then(function() {
                var data = JSON.parse(JSON.stringify($scope.whatsnew_changelog));
                data.createdAt = new Date(new Date($scope.whatsnew_changelog.createdAt).toString());
                data.imageName = imagename;

                ApiService.admin('whatsnew-changelog/' + ($scope.editing ? $stateParams.id : ''), data, ($scope.editing ? 'PUT' : 'POST')).then(function () {
                    locale.ready('admin').then(function () {
                        vrmNotificationsService.add({ type: vrmNotificationType.SUCCESS, message: locale.getString('admin.whatsnew_changelog_saved') });
                        $state.go(browseState);
                    });
                });
            })
        }
    }
})();
